import { BonusOrdinalRatingEnum } from '@sorare/core/src/__generated__/globalTypes';
import { Color } from '@sorare/core/src/style/types';

export const colorPerBonusRating: Record<BonusOrdinalRatingEnum, Color> = {
  [BonusOrdinalRatingEnum.VERY_LOW]: 'var(--c-score-veryLow)',
  [BonusOrdinalRatingEnum.LOW]: 'var(--c-score-low)',
  [BonusOrdinalRatingEnum.MEDIUM]: 'var(--c-score-mediumLow)',
  [BonusOrdinalRatingEnum.HIGH]: 'var(--c-score-medium)',
  [BonusOrdinalRatingEnum.VERY_HIGH]: 'var(--c-score-mediumHigh)',
  [BonusOrdinalRatingEnum.EXCEPTIONAL]: 'var(--c-score-high)',
};
